import useTranslator from "../../hooks/useTranslator";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { Form } from "react-bootstrap";
import { streetTypes } from "../../helper/common";
import Select from "react-select";
import provincesData from "../../Utils/provincia_municipios.json";

const FullAddressFormModal = ({
  isLandlord,
  setIsAddManuallyModal,
  formData,
  handleInputChange,
  handleSubmit,
  setStep,
  onClose,
  isEdit = false,
  submitLoading,
}) => {
  const { _t } = useTranslator();

  const compactSelectStyles = (custom = {}) => ({
    control: (base, state) => ({
      ...base,
      minHeight: "none",
      height: "var(--select-height, 20px)",
      border: "none",
      boxShadow: "none",
      fontSize: "var(--select-font-size, 0.972vw)",
      paddingLeft: "0",
      cursor: "pointer",
      backgroundColor: "transparent",
      display: "flex",
      alignItems: "center",
      ...custom.control,
    }),
    valueContainer: (base, state) => ({
      ...base,
      height: "var(--select-height, 20px)",
      padding: "0",
      display: "flex",
      alignItems: "center",
      overflow: "visible",
      ...(state.isDisabled && {
        paddingTop: "1px",
      }),
      ...custom.valueContainer,
    }),
    singleValue: (base) => ({
      ...base,
      margin: 0,
      textAlign: "left",
      overflow: "visible",
      color: "#000",
      ...custom.singleValue,
    }),
    placeholder: (base) => ({
      ...base,
      textAlign: "left",
      margin: 0,
      overflow: "visible",
      color: "#7f7f7f",
      ...custom.placeholder,
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      height: "var(--select-height, 20px)",
      lineHeight: "var(--select-height, 20px)",
    }),
    indicatorsContainer: () => ({
      display: "none",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "0",
      ...custom.dropdownIndicator,
    }),
  });

  return (
    <div
      className={`addressModal steps-wrapper ${isLandlord && "resend-text"}`}
    >
      <h4 className="step-name">
        {isEdit ? _t("editYourAddress") : _t("whatIsYourAddress")}
      </h4>
      <div
        className="cursor-pointer"
        onClick={() => setIsAddManuallyModal(false)}
      >
        <img src={Cancelimg} alt="icon" className="canceicon topRightIcon" />
      </div>
      <Form className="loginform" onSubmit={handleSubmit}>
        <div className="auth-form authForm">
          {!isEdit && (
            <div
              className="forminput form-mobile-gap customInput row100 relative"
              id="custom-select-search"
            >
              <label className="forminput label-text">{_t("streetType")}</label>
              <Select
                classNamePrefix="react-select custom-react-select-styling"
                name="street_type"
                value={
                  formData?.street_type
                    ? {
                        label: formData.street_type,
                        value: formData.street_type,
                      }
                    : null
                }
                options={streetTypes.map((type) => ({
                  label: type,
                  value: type,
                }))}
                placeholder={_t("enterStreetType")}
                onChange={(selected) =>
                  handleInputChange({
                    target: {
                      name: "street_type",
                      value: selected?.value || "",
                    },
                  })
                }
                styles={compactSelectStyles()}
                isSearchable
                required
              />
              <img
                src="/images/down-arrow-grey.svg"
                className="downArrow"
                alt="arrow"
              />
            </div>
          )}
          <div className="forminput form-mobile-padding customInput row50">
            <label className="forminput label-text">{_t("street")}</label>
            <input
              type="text"
              className="form-control user-auth"
              name="street"
              value={formData?.street}
              onChange={handleInputChange}
              required
              placeholder={_t("enterStreet")}
            />
          </div>
          <div className="forminput form-mobile-padding customInput row50">
            <label className="forminput label-text">{_t("number")}</label>
            <input
              type="text"
              className="form-control user-auth"
              name="street_number"
              value={formData?.street_number}
              onChange={handleInputChange}
              required
              placeholder={_t("enterNumber")}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                  "Delete",
                ];
                if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          <div className="forminput form-mobile-padding customInput row50">
            <label className="forminput label-text">{_t("postCode")}</label>
            <input
              type="text"
              className="form-control user-auth"
              name="postcode"
              value={formData?.postcode}
              onChange={handleInputChange}
              maxLength={5}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                  "Delete",
                ];
                if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
              required
              placeholder={_t("enterPostCode")}
            />
          </div>
          <div className="forminput form-mobile-padding customInput row50">
            <label className="forminput label-text">{_t("stairway")}</label>
            <input
              type="text"
              className="form-control user-auth"
              name="staircase"
              value={formData?.staircase}
              onChange={handleInputChange}
              required
              placeholder={_t("Enter Stairway")}
            />
          </div>
          <div className="forminput form-mobile-padding customInput row50">
            <label className="forminput label-text">{_t("floorNumber")}</label>
            <input
              type="text"
              className="form-control user-auth"
              name="floor"
              value={formData?.floor}
              onChange={handleInputChange}
              required
              placeholder={_t("enterFloorNumber")}
              onInput={(e) => {
                let value = e.target.value.replace(/\D/g, "");

                if (value !== "" && Number(value) > 40) {
                  value = "40";
                }

                e.target.value = value;
              }}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                  "Delete",
                ];
                if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          <div className="forminput form-mobile-padding customInput row50">
            <label className="forminput label-text">{_t("letter")}</label>
            <input
              type="text"
              className="form-control user-auth"
              name="door"
              value={formData?.door}
              onChange={handleInputChange}
              required
              placeholder={_t("enterLetter")}
            />
          </div>
          <div
            className="forminput form-mobile-padding customInput row50 relative"
            id="custom-select-search"
          >
            <label className="forminput label-text">{_t("province")}</label>
            <Select
              classNamePrefix="react-select"
              name="province"
              value={
                formData?.province
                  ? { label: formData.province, value: formData.province }
                  : null
              }
              options={provincesData.map((p) => ({
                label: p.Provincia,
                value: p.Provincia,
              }))}
              placeholder={_t("selectProvince")}
              styles={compactSelectStyles()}
              onChange={(selected) => {
                handleInputChange({
                  target: { name: "province", value: selected?.value || "" },
                });
                handleInputChange({
                  target: { name: "municipality", value: "" },
                });
              }}
              isSearchable
              required
            />
            <img
              src="/images/down-arrow-grey.svg"
              className="downArrow"
              alt="arrow"
            />
          </div>
          <div
            className={`forminput form-mobile-padding customInput row50 relative ${!formData?.province ? "input-disabled" : ""}`}
            id="custom-select-search"
          >
            <label className="forminput label-text">{_t("municipality")}</label>
            <Select
              classNamePrefix="react-select"
              name="municipality"
              value={
                formData?.municipality
                  ? {
                      label: formData.municipality,
                      value: formData.municipality,
                    }
                  : null
              }
              options={
                formData?.province
                  ? provincesData
                      .find((p) => p.Provincia === formData.province)
                      ?.municipios.map((m) => ({ label: m, value: m })) || []
                  : []
              }
              placeholder={
                formData?.province
                  ? _t("selectMunicipality")
                  : _t("selectProvinceFirst")
              }
              onChange={(selected) =>
                handleInputChange({
                  target: {
                    name: "municipality",
                    value: selected?.value || "",
                  },
                })
              }
              styles={compactSelectStyles()}
              isSearchable
              isDisabled={!formData?.province}
              required
            />
            <img
              src="/images/down-arrow-grey.svg"
              className="downArrow"
              alt="arrow"
            />
          </div>
          <div className="forminput form-mobile-padding customInput row50">
            <label className="forminput label-text">{_t("bedrooms")}</label>
            <input
              type="text"
              className="form-control user-auth"
              name="bedrooms"
              value={formData?.bedrooms}
              onChange={handleInputChange}
              required
              placeholder={_t("enterBedrooms")}
              onInput={(e) => {
                let value = e.target.value.replace(/\D/g, "");

                if (value !== "" && Number(value) > 10) {
                  value = "10";
                }

                e.target.value = value;
              }}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                  "Delete",
                ];
                if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          <div className="forminput form-mobile-padding customInput row50">
            <label className="forminput label-text">{_t("bathrooms")}</label>
            <input
              type="text"
              className="form-control user-auth"
              name="washrooms"
              value={formData?.washrooms}
              onChange={handleInputChange}
              required
              placeholder={_t("enterBathrooms")}
              onInput={(e) => {
                let value = e.target.value.replace(/\D/g, "");

                if (value !== "" && Number(value) > 10) {
                  value = "10";
                }

                e.target.value = value;
              }}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                  "Delete",
                ];
                if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          <div className="forminput form-mobile-gap customInput row100">
            <label className="forminput label-text">
              {_t("propertyReferenceOptional")}
            </label>
            <input
              className="form-control user-auth"
              name="property_reference"
              value={formData?.property_reference}
              onChange={handleInputChange}
              placeholder={_t("enterPropertyReference")}
            />
          </div>
          <div className="btngroup row100 d-flex align-items-center justify-content-center custom-gap-3">
            <button
              className="commonButtonPropertyDark form-mobile-button-color commonButtonPropertyLight"
              type="button"
              onClick={(e) => (isEdit ? onClose() : setStep(1))}
            >
              {_t("goBack")}
            </button>
            <button
              disabled={submitLoading}
              className="btnNext commonButtonPropertyDark"
              type="submit"
            >
              {_t("submit")}
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default FullAddressFormModal;
